import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import MapProvider from '../../context/MapProvider'
import { detectCityFromURL } from '../../utils/cityDetector'
import { readSavedViewport } from '../../utils/mapViewport'
import { useCities } from '../../context/CitiesContext'

// Valores por defecto (Loja) para cuando no hay configuración disponible
const DEFAULT_CENTER = [-79.2042, -3.9931]
const DEFAULT_ZOOM = 14

const MapWrapper = ({ children }) => {
  const location = useLocation()
  const city = detectCityFromURL(location.pathname)
  const lightPresetRedux = useSelector(state => state.mapState.lightPreset.current)

  // Obtener configuración de la ciudad desde el contexto
  const { getCityBySlug, getDefaultCity } = useCities()
  const cityConfig = getCityBySlug(city) || getDefaultCity()

  // Viewport guardado en la sesión: solo se reutiliza si es de esta misma ciudad.
  const savedViewport = readSavedViewport()
  const useSavedPosition = Boolean(savedViewport && savedViewport.city === city)

  // Usar valores por defecto si cityConfig no está disponible
  const centerLng = cityConfig?.center?.[0] ?? DEFAULT_CENTER[0]
  const centerLat = cityConfig?.center?.[1] ?? DEFAULT_CENTER[1]
  const cityZoom = cityConfig?.zoom ?? DEFAULT_ZOOM

  const lng = useSavedPosition ? savedViewport.center[0] : centerLng
  const lat = useSavedPosition ? savedViewport.center[1] : centerLat
  const zoom = useSavedPosition ? savedViewport.zoom : cityZoom

  const lightPreset =
    localStorage.getItem('ArbolEc_lightPreset') ?? lightPresetRedux ?? 'day'

  return (
    <MapProvider
      styleUrl={`mapbox://styles/johgg10/cmhnl5obn000r01rz3cjq11bq`}
      center={[lng, lat]}
      zoom={zoom}
      lightPreset={lightPreset}>
      {children}
    </MapProvider>
  )
}

export default MapWrapper
